import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// Generated by Copilot — Migrated from Userfront to Clerk
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import MainLayout from "./components/MainLayout";
import Dashboard from './components/Dashboard';
import Signup from "./components/Signup";
import ListadoRFC from "./components/ListadoRFC";
import Consultar from "./components/Consultar";
import Configuracion from "./components/Configuracion";
import Ayuda from "./components/Ayuda";
import Suscripciones from "./components/Suscripciones";
import Suscripcion_Exitosa from "./components/Suscripcion_Exitosa";
import Facturin from "./components/Facturin";
import FeatureRoute from "./components/FeatureRoute";
import Status from "./components/Status";
import AdminRoute from "./components/AdminRoute";
import AdminDashboard from "./components/admin/AdminDashboard";
import AdminUserDetail from "./components/admin/AdminUserDetail";
import AdminReports from "./components/admin/AdminReports";
import AdminDailySummaryReport from "./components/admin/AdminDailySummaryReport";
import AdminMonthlyRfcReport from "./components/admin/AdminMonthlyRfcReport";
import AdminStripeEvents from "./components/admin/AdminStripeEvents";
import AdminSendEmails from "./components/admin/AdminSendEmails";
import Playground from "./components/Playground";

const App = () => {
 
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Dashboard />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Dashboard />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/listado-rfc"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ListadoRFC />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/consultar"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Consultar />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/configuracion"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Configuracion />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/suscripciones"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Suscripciones />
              </MainLayout>
            </ProtectedRoute>
          }
        />
         <Route
          path="/suscripcion-exitosa"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Suscripcion_Exitosa />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/facturin"
          element={
            <ProtectedRoute>
              <FeatureRoute feature="facturin">
                <MainLayout>
                  <Facturin />
                </MainLayout>
              </FeatureRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/playground"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Playground />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/status"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Status />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ayuda"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Ayuda />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <MainLayout>
                  <AdminDashboard />
                </MainLayout>
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users/:userUuid"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <MainLayout>
                  <AdminUserDetail />
                </MainLayout>
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/reports"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <MainLayout>
                  <AdminReports />
                </MainLayout>
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/reports/daily-summary"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <MainLayout>
                  <AdminDailySummaryReport />
                </MainLayout>
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/reports/monthly-rfc-usage"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <MainLayout>
                  <AdminMonthlyRfcReport />
                </MainLayout>
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/stripe-events"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <MainLayout>
                  <AdminStripeEvents />
                </MainLayout>
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/send-emails"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <MainLayout>
                  <AdminSendEmails />
                </MainLayout>
              </AdminRoute>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
